import { useEffect } from "react";

export default function SEOHead({ title, description, keywords, ogImage }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name, content) => {
      if (!content) return;
      let tag = document.querySelector(`meta[name='${name}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };
    const setOG = (prop, content) => {
      if (!content) return;
      let tag = document.querySelector(`meta[property='${prop}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", prop);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };
    setMeta("description", description);
    setMeta("keywords", keywords);
    setOG("og:title", title);
    setOG("og:description", description);
    setOG("og:image", ogImage);
  }, [title, description, keywords, ogImage]);

  return null;
}
